import PropTypes from 'prop-types';

import MessageContent from './MessageContent';

// Class names per chat surface, preserved exactly so existing CSS applies.
const VARIANTS = {
  messaging: {
    me: 'message from-me',
    other: 'message from-other',
    body: 'message-body',
    timestamp: 'message-time-stamp',
    linkify: true,
  },
  videoChat: {
    me: 'message from-me',
    other: 'message',
    body: 'chat-message-body',
    timestamp: 'message-timestamp',
  },
  videoSidebar: {
    me: 'sidebar-message-me',
    other: 'sidebar-message-you',
    body: 'sidebar-message-body',
    timestamp: 'sidebar-message-timestamp',
    wrapBody: true,
  },
};

function MessageBubble({
  variant,
  fromMe = false,
  body = '',
  timestamp = null,
}) {
  const classes = VARIANTS[variant];
  const messageBody = classes.linkify ? (
    <MessageContent content={body} />
  ) : (
    body
  );

  const bodyEl = classes.wrapBody ? (
    <div style={{ width: '100%' }}>
      <p className={classes.body}>{messageBody}</p>
    </div>
  ) : (
    <p className={classes.body}>{messageBody}</p>
  );
  const timestampEl = <p className={classes.timestamp}>{timestamp}</p>;

  return (
    <div className={fromMe ? classes.me : classes.other}>
      {fromMe ? bodyEl : timestampEl}
      {fromMe ? timestampEl : bodyEl}
    </div>
  );
}

MessageBubble.propTypes = {
  variant: PropTypes.oneOf(Object.keys(VARIANTS)).isRequired,
  fromMe: PropTypes.bool,
  body: PropTypes.string,
  timestamp: PropTypes.node,
};

export default MessageBubble;
